import { RelationshipsEnum } from "../../Types/Enums/RelationshipsEnum";

export const RELATIONSHIPS = [
  { id: RelationshipsEnum.PARENT, labels: { 0: "Madre/Padre", 1: "Parent" } },
  { id: RelationshipsEnum.PARTNER, labels: { 0: "Pareja", 1: "Couple" } },
  { id: RelationshipsEnum.SIBLING, labels: { 0: "Hermana/o", 1: "Sibling" } },
  { id: RelationshipsEnum.OFFSPRING, labels: { 0: "Hija/o", 1: "Daughter/Son" } },
  { id: RelationshipsEnum.OTHER, labels: { 0: "Otro", 1: "Other" } }
];